import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
import axiosInstance from '@/parts/axiosConfig.js';
import vueAxios from 'vue-axios';

store.commit('setAxiosInstance', axiosInstance);
const app = createApp(App).provide('bootstrap',bootstrap).use(router).use(store);
app.use(vueAxios,axiosInstance);
app.mount('#app');